export const studentsData = [
    {
        name: "John",
        birthDate: "5/24/2024",
        userName: "john",
        password: "jhon123",
        email: "john@example.com",
        studentId: "STD_123",
    },
    {
        name: "Jane",
        birthDate: "6/15/1990",
        userName: "jane",
        password: "jane456",
        email: "jane@example.com",
        studentId: "STD_456",
    },
    {
        name: "David",
        birthDate: "9/2/1985",
        userName: "david",
        password: "david789",
        email: "david@example.com",
        studentId: "STD_789",
    },
    {
        name: "Emily",
        birthDate: "3/10/2001",
        userName: "emily",
        password: "emily123",
        email: "emily@example.com",
        studentId: "STD_234",
    },
    {
        name: "Michael",
        birthDate: "7/18/1995",
        userName: "michael",
        password: "michael456",
        email: "michael@example.com",
        studentId: "STD_567",
    },
    {
        name: "Sophia",
        birthDate: "11/29/1988",
        userName: "sophia",
        password: "sophia789",
        email: "sophia@example.com",
        studentId: "STD_890",
    },
    {
        name: "Daniel",
        birthDate: "2/8/2003",
        userName: "daniel",
        password: "daniel123",
        email: "daniel@example.com",
        studentId: "STD_345",
    },
    {
        name: "Olivia",
        birthDate: "10/5/1999",
        userName: "olivia",
        password: "olivia456",
        email: "olivia@example.com",
        studentId: "STD_678",
    },
    {
        name: "Matthew",
        birthDate: "4/12/1992",
        userName: "matthew",
        password: "matthew789",
        email: "matthew@example.com",
        studentId: "STD_901",
    },
    {
        name: "Ava",
        birthDate: "8/30/2000",
        userName: "ava",
        password: "ava123",
        email: "ava@example.com",
        studentId: "STD_456",
    },
]